import { StyleSheet, Text, View } from '@react-pdf/renderer';

import { useMemo } from 'react';

const RTLText = ({ children, style = {}, reverse = false }) => {
	// Check if the text contains Arabic characters
	const checkArabicCharacters = (text) => {
		if (!text) return false;
		const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
		return arabicPattern.test(text);
	};

	// Check if the text contains Arabic characters and if it is a single word or not
	const checkContent = (innerChild) => {
		if (isNaN(Number(innerChild)) && typeof innerChild === 'string') {
			if (checkArabicCharacters(innerChild)) {
				if (innerChild.split(' ').length > 1) {
					return true;
				}
			}
		}
		return false;
	};

	const commonStyle = useMemo(
		() =>
			StyleSheet.create({
				display: 'flex',
				flexWrap: 'wrap',
				whiteSpace: 'normal',
				flexDirection: checkContent(children) ? 'row-reverse' : 'row',
				width: '100%'
			}),
		[checkContent, children]
	);
	return checkContent(children) ? (
		<>
			{reverse ? (
				<View style={[style, commonStyle]}>
					{children
						.split(' ')
						.reverse()
						.map((word, index) => (
							<Text key={index}>
								{String(word)}
								{` `}
							</Text>
						))}
				</View>
			) : (
				<View style={[style, commonStyle]}>
					{children.split(' ').map((word, index) => (
						<Text key={index}>
							{String(word)}
							{` `}
						</Text>
					))}
				</View>
			)}
		</>
	) : (
		<Text style={[commonStyle, style]}>{String(children)}</Text>
	);
};

export default RTLText;
